import {
  ContractDatePresetDto,
  ContractStatusDto,
  type ContractReportQueryDto,
  type SavedReportDto,
  SavedReportListDto,
} from "../../autogen/bff-api";
import { osloDate } from "../download/listExport";
import { withEncodedFilters } from "./savedReportLists";

export type StoredReport = Pick<SavedReportDto, "list" | "query" | "createdAt" | "modifiedAt">;

// 7752e59488 removed the button, and reached development on 2026-11-01.
const OLD_BUTTON_GONE_FROM = "2026-11-02";

const savedByTheOldButton = (q: Partial<ContractReportQueryDto>, report: StoredReport): boolean => {
  const from = q.endDateFrom ?? "";
  const savedOn = [report.createdAt, report.modifiedAt].map(osloDate);
  return (
    q.statuses?.length === 1 &&
    q.statuses[0] === ContractStatusDto.Active &&
    !q.datePresets?.endDate &&
    savedOn.some((day) => day === from && day < OLD_BUTTON_GONE_FROM) &&
    q.endDateTo === `${from.slice(0, 4)}-12-31`
  );
};

const asThisYearPreset = (q: Partial<ContractReportQueryDto>): Partial<ContractReportQueryDto> => {
  const preset = { ...q, datePresets: { ...q.datePresets, endDate: ContractDatePresetDto.ThisYear } };
  delete preset.endDateFrom;
  delete preset.endDateTo;
  return preset;
};

export const savedReportQuery = (report: StoredReport): string =>
  report.list !== SavedReportListDto.Contracts
    ? report.query
    : withEncodedFilters<Partial<ContractReportQueryDto>>(report.query, (q) =>
        savedByTheOldButton(q, report) ? asThisYearPreset(q) : q
      );
